import { useQuery } from "@tanstack/react-query";

import { telemetryAjax } from "../../ajax/TelemetryAjax";
import { ErrorResponse } from "../../DTOs/Common/ErrorResponse";
import { DigBlockFenceDTO } from "../../DTOs/Telemetry/DigBlockFenceDTO";

export const DIG_BLOCK_FENCE_QUERY_KEY = ["telemetry", "digBlockFences"];

export function useDigBlockFences(): DigBlockFenceDTO[] {
  const { data = [] } = useQuery({
    queryKey: DIG_BLOCK_FENCE_QUERY_KEY,
    queryFn: async () => {
      const res = await telemetryAjax.getLiveDigBlockFences();
      // Note: this endpoint returns the array directly rather than a PagedResult, matching the blast
      // pattern fences - so the error guard is the only unwrapping needed.
      if (ErrorResponse.isErrorResponse(res)) return [] as DigBlockFenceDTO[];
      return res;
    },
    staleTime: 5 * 60 * 1000,
  });

  return data;
}
